import { StatusCell } from './StatusCell';

export default StatusCell;
